import React, { useState } from 'react';
import ThemeToggle from './ThemeToggle';

function Nav({ items, scrolled }) {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <nav className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
            <a href="/" className="nav__brand">
                AS<span className="nav__brand-accent">()</span>
            </a>

            <ul className={`nav__links ${menuOpen ? 'nav__links--open' : ''}`}>
                {items.map((item) => (
                    <li key={item.id}>
                        <a
                            className="nav__link"
                            href={`#${item.id}`}
                            onClick={() => setMenuOpen(false)}
                        >
                            {item.label}
                        </a>
                    </li>
                ))}
            </ul>

            <div className="nav__actions">
                <ThemeToggle />
                <button
                    className="nav__toggle"
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Toggle navigation"
                    aria-expanded={menuOpen}
                >
                    <span />
                    <span />
                    <span />
                </button>
            </div>
        </nav>
    );
}

export default Nav;
